import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-track-record-applicant',
  templateUrl: './track-record-applicant.component.html',
  styleUrls: ['./track-record-applicant.component.css'],
})
export class TrackRecordApplicantComponent implements OnInit {
  trackrecord: FormGroup;
  private saveApi = environment.url + 'coe/trackrecord/save';
  private getApi = environment.url + 'coe/trackrecord/get?id=';
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialog: MatDialog
  ) {
    this.trackrecord = this.fb.group({
      id: [0],
      applicationId: [sessionStorage.getItem('applicationId')],
      coeFacilities: [''],
      totalBeneficiaries: [''],
      numberOfManpower: [''],
      numberOfIncubatorStartup: [''],
      numberOfStartup: [''],
      startupFund: [''],
      totalFund: [''],
      incubatorFundRaised: [''],
      numberOfPatents: [''],
      totalBuiltUpArea: [''],
      numberOfStaff: [''],
      incubationHead: [''],
    });
  }

  ngOnInit(): void {
    this.getDataApi();
  }

  showForm: boolean = false;
  get setting() {
    return this.trackrecord.controls;
  }
  getValue: any = {};
  disableBtn: boolean;
  show;
  // get data
  getDataApi() {
    this.getdata.amizhthLoader('show');
    this.makeapi
      .method(this.getApi + sessionStorage.getItem('applicationId'), '', 'get')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        this.getValue = data;
        if (
          data.incubatorFundRaised !== undefined &&
          data.incubatorFundRaised !== null
        ) {
          data.incubatorFundRaised = data.incubatorFundRaised.toString();
        }
        this.trackrecord.patchValue(data);

        if (data.edit === false) {
          this.showForm = true;
        } else {
          this.showForm = false;
        }
      });
  }
  // cancle
  cancleBtn() {
    this.showForm = false;
    this.trackrecord.reset();
  }
  // Prevent the Enter key from submitting the form
  preventEnterKey(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent the default action
    }
  }
  // save
  saveBtn() {
    let getform = this.trackrecord.value;
    if (this.trackrecord.invalid) {
      this.trackrecord.markAllAsTouched();
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      getform.applicationId = sessionStorage.getItem('applicationId');
      this.makeapi.method(this.saveApi, getform, 'post').subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        if (data.responseStatus == 'Success') {
          this.notify.notifysuccess(data.responseStatus);
          this.getDataApi();
          this.router.navigateByUrl('admin/coe/feasibility-sustainability');
        } else {
          this.notify.notifyError(data.responseStatus);
        }
      });
    }
  }
}
